import React from 'react';
import { AppBar, Toolbar, IconButton, Typography } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import TextFieldsIcon from '@mui/icons-material/TextFields';

function ToolbarComponent() {
  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          画像編集アプリ
        </Typography>
        <IconButton color="inherit">
          <ImageIcon />
        </IconButton>
        <IconButton color="inherit">
          <TextFieldsIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
}

export default ToolbarComponent;